import React, { useState } from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Aarav Mehta",
    role: "Customer",
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    rating: 5,
    text: "Absolutely loved the shopping experience! The delivery was super fast, and the product quality exceeded my expectations. Will definitely come back for more.",
  },
  {
    name: "Neha Sharma",
    role: "Customer",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    rating: 4,
    text: "Great variety of products at reasonable prices. Customer support was prompt and helpful when I had a query about my order. Highly recommend!",
  },
  {
    name: "Rajiv Nair",
    role: "Customer",
    image: "https://randomuser.me/api/portraits/men/76.jpg",
    rating: 5,
    text: "I ordered a smartphone and received it within 2 days! Packaging was excellent and the device was authentic and brand new. Very satisfied with the service.",
  },
  {
    name: "Priya Desai",
    role: "Customer",
    image: "https://randomuser.me/api/portraits/women/72.jpg",
    rating: 5,
    text: "This is my go-to website for fashion. The styles are trendy and affordable. Plus, the return process is hassle-free. Loved my last order!",
  },
  {
    name: "Manish Gupta",
    role: "Customer",
    image: "https://randomuser.me/api/portraits/men/12.jpg",
    rating: 4,
    text: "I bought a few kitchen essentials and they arrived well-packed and on time. Quality is good for the price. Will explore more from here soon.",
  },
];

const Testimonials = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const testimonialsPerPage = 3;

  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  const startIndex = (currentPage - 1) * testimonialsPerPage;
  const currentTestimonials = testimonials.slice(
    startIndex,
    startIndex + testimonialsPerPage
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-4 bg-white">
      <h2 className="text-3xl font-bold mb-6">Client Testimonials</h2>

      <div className="grid md:grid-cols-3 gap-6">
        {currentTestimonials.map((t, index) => (
          <div
            key={index}
            className="border rounded-lg p-6 shadow-sm bg-white hover:shadow-md transition"
          >
            <FaQuoteLeft className="text-orange-700 text-3xl mb-4" />
            <p className="text-gray-600 mb-6 text-sm">{t.text}</p>
            <div className="flex items-center gap-4">
              <img
                src={t.image}
                alt={t.name}
                className="w-10 h-10 rounded-full"
              />
              <div>
                <h4 className="text-sm font-semibold">{t.name}</h4>
                <p className="text-xs text-gray-400">{t.role}</p>
              </div>
              <div className="ml-auto flex text-orange-400">
                {[...Array(t.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-8 gap-4">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-sm font-medium">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Testimonials;
